export default {
  namespaced: true,
  state: {
    processos: [],
    usuarioLogado: null,
    sidebarOpen: false,
  },
  getters: {
    getSidebarOpen(state) {
      return state.sidebarOpen;
    },
    getProcessos(state) {
      return state.processos;
    },
    getUsuarioLogado(state) {
      return state.usuarioLogado;
    },
  },
  mutations: {
    setProcessos(state, processos) {
      state.processos = processos;
    },
    setUsuarioLogado(state, usuarioLogado) {
      state.usuarioLogado = usuarioLogado;
    },

    setSidebarOpen(state, isOpen) {
      state.sidebarOpen = isOpen;
    },
  },
  actions: {},
};
